import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Endpoints } from "../../Global/Endpoints";
import '../CheckinWithYou/fourthTrimester.css';
import CustomDropdown from "../../CustomControls/dropdown";

import loginImage01 from "../../assets/images/registration/registration-steps-image-01.jpg";
import loginImage02 from "../../assets/images/registration/registration-steps-image-03.jpg";
import loginImage03 from "../../assets/images/registration/registration-steps-image-04.jpg";

const FourthTrimesterDeliveryDetails = () => {
  const userInfo = useSelector((state) => state.userData);
  const token = localStorage.getItem('AccessToken');
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const numberOfBabies = location.state?.numberOfBabies || 1; // Default to 1 if not provided
  const address = location.state.Address;
  const WINOnesieGift=location.state.WINOnesieGift;
  const deliveryDate = location.state?.deliveryDate || "";
  //const {Address, step = 3, totalSteps = 4 } = location.state || {};

  
  
   // State for the fetched dropdown values
   const [hospitalNames, setHospitalNames] = useState([]);
   const [obstetricians, setObstetricians] = useState([]);
   const [pediatricians, setPediatricians] = useState([]);
   const [errors, setErrors] = useState({});
   const [filteredHospitals, setFilteredHospitals] = useState([]);
const [filteredObstetricians, setFilteredObstetricians] = useState([]);
const [filteredPediatricians, setFilteredPediatricians] = useState([]);
const { commonData: passedCommonData, babies: passedBabies, isMetric: passedIsMetric } = location.state || {};
const [isMetric, setIsMetric] = useState(passedIsMetric ?? false);
const inchOptions = Array.from({ length: 40 }, (_, i) => `${i}`);
const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

  


  // State for common parent-level fields
  const [commonData, setCommonData] = useState(location.state?.commonData ||{
    // deliveryType: "",
    // hospitalName: "",
    // Obstetrician: "",
    // Pediatrician: "",
    // LengthType: isMetric ? "cm" : "inches",
    // WeightType: isMetric ? "kg" : "lbs",
  //   LengthType: "cm", // Default based on isMetric (false)
  // WeightType: "kg", 
  deliveryType: passedCommonData?.deliveryType || "",
  hospitalName: passedCommonData?.hospitalName || "",
  Obstetrician: passedCommonData?.Obstetrician || "",
  Pediatrician: passedCommonData?.Pediatrician || "",
  LengthType: passedIsMetric ? "cm" : "inches",
  WeightType: passedIsMetric ? "kg" : "lbs",
  Address: passedCommonData?.Address || address,
  WINOnesieGift: passedCommonData?.WINOnesieGift || WINOnesieGift,
  });
  useEffect(() => {
    setCommonData((prevData) => ({
      ...prevData,
      LengthType: isMetric ? "inches" : "cm",
      WeightType: isMetric ? "lbs" : "kg",
    }));
  }, [isMetric]);

  // State for each baby's details
  const [babies, setBabies] = useState(passedBabies ||
    Array.from({ length: numberOfBabies }, () => ({
      name: "",
      weight: "",
      length: "",
      nicu: "",
    }))
  );

  const handleFilterChange = (type, value) => {
    const trimmedValue = value.replace(/^\s+/, ""); // Remove leading spaces
  handleCommonChange(type, trimmedValue);
  
     // Trim value to remove leading/trailing spaces and check if it has any characters
  //const trimmedValue = value.trim();

  if (trimmedValue.length === 0) {
    // If input is empty or only spaces, clear the dropdown
    if (type === "hospitalName") {
      setFilteredHospitals([]);
    } else if (type === "Obstetrician") {
      setFilteredObstetricians([]);
    } else if (type === "Pediatrician") {
      setFilteredPediatricians([]);
    }
    return;
  }

  if (type === "hospitalName") {
    const filtered = hospitalNames.filter((name) =>
      name.toLowerCase().includes(trimmedValue.toLowerCase())
    );
    setFilteredHospitals(filtered.length > 0 ? filtered : []);
  } else if (type === "Obstetrician") {
    const filtered = obstetricians.filter((name) =>
      name.toLowerCase().includes(trimmedValue.toLowerCase())
    );
    setFilteredObstetricians(filtered.length > 0 ? filtered : []);
  } else if (type === "Pediatrician") {
    const filtered = pediatricians.filter((name) =>
      name.toLowerCase().includes(trimmedValue.toLowerCase())
    );
    setFilteredPediatricians(filtered.length > 0 ? filtered : []);
  }
};
  
  const handleSelection = (type, value) => {
    handleCommonChange(type, value);
  
    if (type === "hospitalName") setFilteredHospitals([]);
    else if (type === "Obstetrician") setFilteredObstetricians([]);
    else if (type === "Pediatrician") setFilteredPediatricians([]);
  };

  // Validation function
const validateForm = () => {
  let tempErrors = {};

  if (!commonData.deliveryType) tempErrors.deliveryType = "Delivery Type is required.";
  if (!commonData.hospitalName) tempErrors.hospitalName = "Hospital Name is required.";
  if (!commonData.Obstetrician) tempErrors.Obstetrician = "Obstetrician is required.";
  if (!commonData.Pediatrician && commonData.Pediatrician !== "") tempErrors.Pediatrician = "Pediatrician is required."; // Ensure only validate if not empty
  if (!commonData.LengthType) tempErrors.LengthType = "Length Type is required.";
  if (!commonData.WeightType) tempErrors.WeightType = "Weight Type is required.";

  babies.forEach((baby, index) => {
    // if (!baby.name) tempErrors[`baby_name_${index}`] = "Baby's Name is required.";
    if (!baby.weight) tempErrors[`baby_weight_${index}`] = "Weight is required.";
    else if (baby.weight == 0) {
      tempErrors[`baby_weight_${index}`] = "Weight must be greater than 0.";
    }
    if (!baby.length) tempErrors[`baby_length_${index}`] = "Length is required.";
    else if (baby.length == 0) {
      tempErrors[`baby_length_${index}`] = "Length must be greater than 0.";
    }

    if (!baby.nicu) tempErrors[`baby_nicu_${index}`] = "Please select an option.";
  });

  setErrors(tempErrors);
  return Object.keys(tempErrors).length === 0; // Return true if no errors
};

  

   // Fetch data from API on component mount
   useEffect(() => {
    const fetchData = async () => {

      try {
        const params = {
          EmailID: userInfo.userData.EmailID,
          DeviceType: "PatientPortal",}

        const response = await axios.post(
          Endpoints.LoadFourthTrimesterDetails,
          { _Params: JSON.stringify(params) },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Connection": "close",
              "Accept": "*/*",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // Extract the data from the response
        const { HospitalNames, Obstetricians, Pediatricians } = response.data;

        // Set the data into state
        setHospitalNames(HospitalNames);
        setObstetricians(Obstetricians);
        setPediatricians(Pediatricians);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []); // Empty dependency array means this effect runs once on mount

  // Handle change for common fields
  const handleCommonChange = (field, value) => {
    setCommonData({ ...commonData, [field]: value });
  };

  // Handle change for baby-specific fields
  const handleBabyChange = (index, field, value) => {
    const updatedBabies = [...babies];
    updatedBabies[index][field] = value;
    setBabies(updatedBabies);
  };

  // Handle next button with validation
const handleNext = () => {
  if (validateForm()) {
    navigate("/fourth-trimester-preview-delivery-details", {
      state: {
        deliveryDate,
        commonData,
        babies,
        isMetric,
        //step: 4,
    //totalSteps,
      },
    });
  } else {
    console.log("Validation failed. Please fill in all required fields.");
  }
};
// const handleToggle = () => {
//   setIsMetric((prev) => !prev);
// };

const handleToggle = () => {
  setIsMetric((prev) => !prev);

  setBabies((prevBabies) =>
    prevBabies.map((baby) => ({
      ...baby,
      weight: "",  // Reset weight
      length: "",  // Reset length
    }))
  );
};

  

  const handleBack = () => {
    navigate("/fourth-trimester-number-of-babies");
  };

  useEffect(() => {
    const myCarousel = document.querySelector("#carouselExampleSlidesOnly");
    if (myCarousel) {
        new window.bootstrap.Carousel(myCarousel, {
          interval: 5000, // Set interval in milliseconds
        });
      }
  }, []);

  return (
    <>
      <div className="registration-block-main">
        <div className="registration-image-wrapper">
          <div id="carouselExampleSlidesOnly" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
              <div className="carousel-item login-carousel-item active" data-bs-interval="5000">
                <img src={loginImage01} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage02} alt="" className="registration-image" />
              </div>
              <div className="carousel-item login-carousel-item" data-bs-interval="5000">
                <img src={loginImage03} alt="" className="registration-image" />
              </div>
            </div>
          </div>
        </div>

        <div className="registration-form-main">
          <div className="registration-form">
            <h2 className="page-heading-bold mb-3">Congratulations!</h2>
            <p>Please answer the following. Your answers will ensure your WIN Nurse Care Advocate can tailor your postpartum support to your unique needs.
            </p>

            {/* COMMON FIELDS */}
            <div className="common-fields">
              <h4 className="page-heading-secondary-black mt-4">Delivery Information</h4>

              <div className="mb-3">
                <label className="form-label win-form-label mandatory">Delivery Details</label>
                <div className="custom-dropdown-100pc-wrapper">
                  <CustomDropdown
                  options = {["C-section","Vaginal"]} 
                  selectedOption={commonData.deliveryType}
                  onChange={(value) => handleCommonChange("deliveryType",value)}
                  placeholder= "Select"
                  />
                </div>
                {errors.deliveryType && <span className="form-field-error-message">{errors.deliveryType}</span>}
              </div>

              <div className="mb-3">
                <label className="form-label win-form-label">Hospital</label>
                
                <input
                  type="text"
                  className="form-control win-form-control w-100-percent mobile-view"
                  placeholder="Search"
                  value={commonData.hospitalName}
                  maxLength={100}
                  onChange={(e) => handleFilterChange("hospitalName", e.target.value)}
                />
                <label className="text-gray ms-2 d-flex">
                  Please type in the search bar to add a new Hospital
                </label>
                 {errors.hospitalName && <span className="form-field-error-message">{errors.hospitalName}</span>}
                              {filteredHospitals.length > 0 && (
                  <ul className="dropdown-list">
                    {filteredHospitals.map((hospital, index) => (
                      <li key={index} onClick={() => handleSelection("hospitalName", hospital)}>
                        {hospital}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label win-form-label">Obstetrician</label>
               
                <input
                  type="text"
                  className="form-control win-form-control w-100-percent mobile-view"
                  placeholder="search"
                  value={commonData.Obstetrician}
                  maxLength={100}
                  onChange={(e) => handleFilterChange("Obstetrician", e.target.value)}

                />
                <label className="text-gray ms-2 d-flex">
                  Please type in the search bar to add a new Obstetrician
                </label>
                 {errors.Obstetrician && <span className="form-field-error-message">{errors.Obstetrician}</span>}
                 {filteredObstetricians.length > 0 && (
                <ul className="dropdown-list">
                  {filteredObstetricians.map((name, index) => (
                    <li key={index} onClick={() => handleSelection("Obstetrician", name)}>
                      {name}
                    </li>
                  ))}
                </ul>
              )}
              </div>

              <div className="mb-3">
                <label className="form-label win-form-label">Pediatrician (optional)</label>
                <input
                  type="text"
                  className="form-control win-form-control w-100-percent mobile-view"
                  placeholder="search"
                  value={commonData.Pediatrician}
                  maxLength={100}
                  onChange={(e) => handleFilterChange("Pediatrician", e.target.value)}
                />
                <label className="text-gray ms-2 d-flex">
                Please type in the search bar to add a new Pediatrician
                </label>
                {filteredPediatricians.length > 0 && (
                <ul className="dropdown-list">
                  {filteredPediatricians.map((name, index) => (
                    <li key={index} onClick={() => handleSelection("Pediatrician", name)}>
                      {name}
                    </li>
                  ))}
                </ul>
              )}
              </div>
              
            </div>

            {/* Toggle for switching between Metric and Imperial units */}
            <div className="d-flex justify-content-between align-items-center mt-5 mb-2">
              <div className="mb-2 row switch-control-wrapper">
                <label className="col-sm-4 model-form-label me-3">Metrics</label>
                <div className="col-sm-4">
                  <label className="switch">
                    <input
                      type="checkbox"
                      className="switch-input"
                      checked={isMetric}
                      onChange={handleToggle}
                    />
                    <span className="slider round"></span>
                  </label>                  
                </div>
                <div className="col-sm-3">
                  <span className="fw-bold">
                  {isMetric ? "lbs/inches" : "kg/cm"}
                  </span>
                </div>
              </div>
            </div>

            {/* BABY-SPECIFIC FIELDS */}
            {babies.map((baby, index) => (
              <div key={index} className="baby-details-section mb-4">
                <h4 className="page-heading-bold-primary-20">BABY {index + 1}</h4>

                <div className="mb-3">
                  <label className="form-label win-form-label mandatory">Baby Name (optional)</label>
                  <input
                    type="text"
                    className="form-control win-form-control w-100-percent mobile-view"
                    placeholder="Baby Name"
                    value={baby.name}
                    maxLength={50}
                    onChange={(e) => handleBabyChange(index, "name", e.target.value)}
                  />
                   {errors[`baby_name_${index}`] && <span className="form-field-error-message">{errors[`baby_name_${index}`]}</span>}
                </div>

                <div className="mb-3 d-flex justify-content-spacebetween align-items-center">
                  <div className="container px-0">
                    <div className="row">
                      <div className="col-md-6 d-flex flex-column switch-control-wrapper mb-3 mb-md-0">
                        <div className="col-3">
                        <label className="form-label win-form-label mandatory">Weight</label>
                        </div>
                        <div className="col-12 p-0">
                          <input
                            type="text"
                            className="form-control win-form-control w-100-percent"
                            placeholder={isMetric ? "lbs" : "kg"}
                            value={baby.weight}
                            maxLength={6} // Allows up to 5 digits + 1 decimal point
                            //pattern="[0-9]*" // Ensures only numbers are allowed
                            onInput={(e) => {
                              // Prevent input of more than 5 digits
                              const value = e.target.value;
                              const regex = /^\d{1,3}(\.\d{0,2})?$/; // Ensures 1-3 digits before decimal, and up to 2 after
                              if (regex.test(value) || value === "") {
                                handleBabyChange(index, "weight", value);
                              }
                            }}
                          />
                        </div>
                        {errors[`baby_weight_${index}`] && <span className="form-field-error-message">{errors[`baby_weight_${index}`]}</span>}
                      </div>

                      <div className="col-md-6 d-flex flex-column switch-control-wrapper">
                        <div className="col-3">
                          <label className="form-label win-form-label mandatory">Length</label>
                        </div>
                        <div className="col-12 p-0 me-2 custom-dropdown-100pc-wrapper">
                        {!isMetric ? (
                        // CM input field
                          <input
                            type="text"
                            className="form-control win-form-control w-100-percent"
                            placeholder={isMetric ? "inches" : "cm"}
                            value={baby.length}
                            maxLength={isMetric ? 5 : 6} // 3 digits + decimal + 2 digits for cm, 2 + decimal + 2 for inches
                            //pattern="[0-9]*" // Ensures only numbers are allowed
                            onInput={(e) => {
                              // Prevent input of more than 5 digits
                              const value = e.target.value;
                                // Regex for validation
                                const cmRegex = /^\d{1,3}(\.\d{0,2})?$/; // Allows 1-3 digits before decimal, 2 after (e.g., 123.45)
                                const inRegex = /^\d{1,2}(\.\d{0,2})?$/; // Allows 1-2 digits before decimal, 2 after (e.g., 12.34)

                                // Apply correct regex based on the selected unit
                                if ((isMetric && inRegex.test(value)) || (!isMetric && cmRegex.test(value)) || value === "") {
                                  handleBabyChange(index, "length", value);
                                }
                            }}
                          />
                          ) : (
                              // Inches dropdown
                              <CustomDropdown
                                options={inchOptions} // e.g., ['0', '0.5', '1', ..., '12']
                                selectedOption={baby.length}
                                onChange={(inches) => handleBabyChange(index, "length", inches)}
                                placeholder="Select inches"
                                searchable={false}
                                disabled={false}
                              />
                            )}
                        </div>
                        {errors[`baby_length_${index}`] && <span className="form-field-error-message">{errors[`baby_length_${index}`]}</span>}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label win-form-label  mandatory">Did your baby spend any time in the NICU?</label>
                  <div className="custom-dropdown-100pc-wrapper">
                  <CustomDropdown
                    options={["Yes", "No"]}
                    selectedOption={baby.nicu === "Y" ? "Yes" : baby.nicu === "N" ? "No" : ""}
                    onChange={(label) => {
                      const value = label === "Yes" ? "Y" : label === "No" ? "N" : "";
                      handleBabyChange(index, "nicu", value);
                    }}
                    placeholder="Select"
                    
                  />
                  </div>
                  
                  {errors[`baby_nicu_${index}`] && <span className="form-field-error-message">{errors[`baby_nicu_${index}`]}</span>}
                </div>
              </div>
            ))}

            

<div className="mt-3 mb-5 d-flex justify-content-between align-items-center">
  {isHighmarkPortal ? (
    //Highmark-specific pagination format
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={handleBack}></button>
      {/* <span className="me-3">{`${step} of ${totalSteps}`}</span> */}
      <span className="me-3">2 of 3</span>
      <button className="next-btn" onClick={handleNext}></button>
    </div>
  ) : (
    //Default buttons for non-SSO users
    <>
      <button
        className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0"
        onClick={handleBack}
        type="button"
      >
        {t('back')}
      </button>
      <button
        className="win-btn-primary mobile-view me-3"
        onClick={handleNext}
      >
        Next
      </button>
    </>
  )}
</div>
            
          </div>
        </div>
      </div>
    </>
  );
};

export default FourthTrimesterDeliveryDetails;
